import moment from "moment";
import { Box,  Grid, TextField, Autocomplete, InputAdornment, CircularProgress, Tooltip } from "@mui/material"
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from "../../../constants";
import { regexConstants } from "../../../constants/regEx"

const EscalationDetails = ({dropDownLoader, reserveRates, onFieldChange, onFocusChange, error, modeType, pltConstants, requireBaseReadingEscalation = false }) => {
    return (
        <Box className="escalation-container">
            <Box className="escalation-box">
                <Grid container spacing={2}>
                    <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            required={requireBaseReadingEscalation || reserveRates?.rate_escalation_interval !== null || reserveRates?.rate_escalation_start_date !== null}
                            id="rate_escalation_percentage"
                            value={reserveRates?.rate_escalation_percentage}
                            onChange={(e, value) => { regexConstants.percantageRegExp.test(e.target.value) ? onFieldChange('rate_escalation_percentage', e.target.value) : e.preventDefault() }}
                            onFocus={() => onFocusChange("rate_escalation_percentage")}
                            label="Reserve Rate Escalation"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            error={error.rate_escalation_percentage}
                            helperText={error.rate_escalation_percentage}
                            slotProps={{
                                inputLabel: { shrink: true },
                                htmlInput: {
                                    maxLength: 5,
                                },
                                input: { endAdornment: (<InputAdornment position="end">%</InputAdornment>) }
                            }}
                            fullWidth
                            disabled={modeType === 'view' || reserveRates?.table_based_esc}
                        />
                    </Grid>
                    {/* <Grid size={{ md: 4, xs: 12 }}>
                        <TextField
                            required={!reserveRates?.is_escalation_mucip ? true : false}
                            id="cost_escalation_percentage"
                            value={reserveRates?.cost_escalation_percentage}
                            onChange={(e, value) => { regexConstants.decimalnodotstart.test(e.target.value) ? onFieldChange('cost_escalation_percentage', e.target.value) : e.preventDefault() }}
                            onFocus={() => onFocusChange("cost_escalation_percentage")}
                            label="Shop Visit Cost Escalation"
                            variant="outlined"
                            size="small"
                            margin="normal"
                            error={error.cost_escalation_percentage}
                            helperText={error.cost_escalation_percentage}
                            slotProps={{
                                inputLabel: { shrink: true },
                                htmlInput: {
                                    maxLength: 5,
                                },
                                input: { endAdornment: (<InputAdornment position="end">%</InputAdornment>) }
                            }}
                            fullWidth
                            disabled={modeType === 'view' }
                        />
                    </Grid> */}

                    <Grid size={{ md: 4, xs: 12 }}>
                        <Autocomplete
                            disablePortal
                            options={pltConstants?.constant_types?.filter(item => item.type === 'escalation_interval')}
                            disabled={modeType === 'view'}
                            getOptionLabel={(option) => option.label || ""}
                            value={reserveRates?.rate_escalation_interval}
                            noOptionsText={dropDownLoader?.account_type ? "loading" : "No Option Available"}
                            onChange={(e, value) => onFieldChange("rate_escalation_interval", value)}
                            onFocus={() => onFocusChange("rate_escalation_interval")}
                            isOptionEqualToValue={(option, value) => option.value === value.value}
                            renderInput={(params) => {
                                const selectedLabel = params?.inputProps?.value || "";
                                return (
                                <Tooltip title={selectedLabel.length > 23 ? selectedLabel : ""} placement="bottom" arrow >
                                <TextField
                                    {...params}
                                    required={requireBaseReadingEscalation || reserveRates?.rate_escalation_percentage !== "" || reserveRates?.rate_escalation_start_date !== null}
                                    label="Escalation Interval"
                                    margin='normal'
                                    size='small'
                                    slotProps={{
                                        inputLabel: {
                                            shrink: true,
                                        },
                                        input:{ ...params?.InputProps,endAdornment: (<>{dropDownLoader?.account_type ? ( <CircularProgress color="inherit" size={20} />) : null}
                                        {params?.InputProps?.endAdornment}
                                        </>
                                       )
                                        }
                                    }}
                                    error={error.rate_escalation_interval}
                                    helperText={error.rate_escalation_interval}
                                    disabled={modeType === 'view'}
                                /></Tooltip>)}}
                        />
                    </Grid>

                    <Grid size={{ md: 4, xs: 12 }}>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                            <DatePicker
                                label="Escalation Start Date"
                                 value={reserveRates?.rate_escalation_start_date ? moment(reserveRates?.rate_escalation_start_date) : null}
                                // onChange={(data, value) => onFieldChange('rate_escalation_start_date', moment(data).format(backendDateFormat))}
                                onChange={(data) => { onFieldChange( "rate_escalation_start_date", data ? moment(data).format(backendDateFormat) : null ); onFocusChange("rate_escalation_start_date"); }}
                                slotProps={{
                                    textField: {
                                        required: requireBaseReadingEscalation || reserveRates?.rate_escalation_percentage !== "" || reserveRates?.rate_escalation_interval !== null,
                                        InputLabelProps: { shrink: true },
                                        size: "small",
                                        margin: "normal",
                                        helperText: error.rate_escalation_start_date,
                                        error: error.rate_escalation_start_date,
                                        onFocus: () => { onFocusChange("rate_escalation_start_date") }
                                    },
                                    field: {
                                        clearable: true,
                                        onClear: () => {
                                            onFieldChange("rate_escalation_start_date", null);
                                        }
                                    },
                                }}
                                sx={{ width: "100%" }}
                                format={fieldDateFormat}
                                disabled={modeType === 'view' || reserveRates?.table_based_esc}
                                />

                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}

export default EscalationDetails